export default __webpack_public_path__ + "../img/28e0a315b4a7d26bd9dfa5cd60618599.png";